import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { AutocompleteModule } from "../shared/components/autocomplete/autocomplete.module";
import { AutocompleteMultiselectComponent } from "./autocomplete-multiselect/autocomplete-multiselect.component";

@NgModule({
  declarations: [AutocompleteMultiselectComponent],
  imports: [CommonModule, AutocompleteModule],
  exports: [AutocompleteMultiselectComponent],
})
export class AutocompleteMultiselectModule {}
